import jwtDecode from 'jwt-decode';
import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';
import getAccessToken from 'functions/getAccessToken';
import { clearAuthDataInLocalStorage } from 'functions/clearAuthDataInLocalStorage';

// eslint-disable-next-line import/no-unresolved

function isExpired(token) {
  let _isExpired = true;

  try {
    _isExpired = jwtDecode(token).expires < Date.now() / 1000;
  } catch (e) {
    console.error(e);
    return _isExpired;
  }

  return _isExpired;
}

export function getBasicHeaders() {
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, PUT, POST',
    'Access-Control-Allow-Headers': 'content-type',
  };
}

export function formAuthHeaders({ accessToken }) {
  return {
    Authorization: `Bearer ${accessToken}`,
  };
}

export async function authHeaders() {
  let accessToken = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  const refreshToken = localStorage.getItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);

  if (!accessToken) {
    return getBasicHeaders();
  }

  if (isExpired(accessToken)) {
    accessToken = await getAccessToken();
  }

  if (isExpired(refreshToken)) {
    clearAuthDataInLocalStorage();
  }

  return {
    ...getBasicHeaders(),
    ...formAuthHeaders({ accessToken }),
  };
}
